import { TariffGroup, Tariff } from '@src/core/buyerApiClient';
import { schedulingContainsMinute } from '@src/common/schedulings';
import type { TariffsPerType } from '../types/tariff';

export const getCorrectTariffFromScheduling = (tariffsPerType: TariffsPerType, tariffGroup: TariffGroup) =>
  tariffGroup.tariffs.find((t) => t.type.id === tariffsPerType.type.id) ?? null;

export const getSelectedTariff = (tariffPerType: TariffsPerType, selectedMinutes: number | null): Tariff | null => {
  for (const scheduling of tariffPerType.schedulings) {
    if (selectedMinutes != null) {
      if (schedulingContainsMinute(scheduling, selectedMinutes)) {
        return getCorrectTariffFromScheduling(tariffPerType, scheduling.tariffGroup);
      }
    } else {
      return getCorrectTariffFromScheduling(tariffPerType, scheduling.tariffGroup);
    }
  }

  if (tariffPerType.tariffGroup) {
    return tariffPerType.tariffGroup.tariffs.find((t) => t.type.id === tariffPerType.type.id) ?? null;
  }

  return null;
};
